import { render, staticRenderFns } from "./zhuanxiangCardList.vue?vue&type=template&id=4d62fe27&"
import script from "./zhuanxiangCardList.vue?vue&type=script&lang=js&"
export * from "./zhuanxiangCardList.vue?vue&type=script&lang=js&"
import style0 from "./zhuanxiangCardList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports